module.exports = __webpack_public_path__ + "img/sample_album.94b60f8.jpeg";